var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOfferSlider3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "#FFF8F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5.172C8 4.068 8.896 4 10 4H30C31.104 4 32 4.068 32 5.172V7.67L20.894 13.224C20.332 13.504 19.668 13.504 19.106 13.224L8 7.67V5.172ZM4.552 10.418L18.212 17.248C19.338 17.812 20.662 17.812 21.788 17.248L35.448 10.418C35.786 10.25 36 9.904 36 9.524V3.172C36 0.962 34.21 0 32 0H8C5.79 0 4 0.962 4 3.172V9.524C4 9.904 4.214 10.25 4.552 10.418ZM36 33.172C36 34.276 35.104 36 34 36H6C4.896 36 4 34.276 4 33.172V20.232C4 19.49 4.782 19.006 5.448 19.338C13.8 23.514 11.234 22.232 18.238 25.734C19.348 26.29 20.656 26.298 21.772 25.754C28.714 22.386 25.796 23.794 34.568 19.582C35.23 19.262 36 19.746 36 20.484V33.172ZM34.212 15.036L20.894 21.696C20.332 21.976 19.668 21.976 19.106 21.696L5.788 15.036C3.13 13.708 0 15.642 0 18.614V35.172C0 37.382 1.79 40 4 40H36C38.21 40 40 37.382 40 35.172V18.614C40 15.642 36.87 13.708 34.212 15.036Z",
    fill: "#F68424"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferSlider3);
export default __webpack_public_path__ + "static/media/offer-slider-3.8f0d1d29358d9e0c3b137122182f8467.svg";
export { ForwardRef as ReactComponent };